<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)"></van-col>
                    <van-col span="12">
                        <div class="banner-title">{{$t('challengeList.history')}}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="list">
            <div class="c-box" v-for="item in info" :key="item.challengeId" @click="toDesc(item)">
                <div class="icon-box">
                    <img class="c-icon" v-if="item.attribute != 0"
                         :src="require(`@/assets/theme/light/sport/01challengeList/0${item.attribute}img.png`)">
                    <img class="c-icon" v-if="item.attribute == 0"
                         :src="item.banner">
                </div>
                <div class="c-title">{{getName(item)}}</div>
                <div class="c-time">{{item.startDate.slice(5, 10).replace(/-/g, '/')}}-{{item.endDate.slice(5, 10).replace(/-/g, '/')}}</div>
                <img class="info-icon" :src="require(`@/assets/theme/${theme}/sport/01challengeList/08info.svg`)">
                <div class="c-info">{{$t('challengeList.join')}}：<span class="c-light">{{item.participantNum}}</span></div>
                <img class="rank-icon" :src="require(`@/assets/theme/${theme}/sport/01challengeList/06rank.svg`)">
                <div class="c-rank" v-if="$i18n.locale == 'zh'">第<span class="c-light"> {{item.rank ? item.rank : '--'}} </span>名</div>
                <div class="c-rank" v-if="$i18n.locale == 'en'">No.<span class="c-light"> {{item.rank ? item.rank : '--'}} </span></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getQueryVariable, getSkin} from '@/utils/comment'
    import {getDistanceDays, formatSeconds} from '@/utils/dateUtils'

    export default {
        name: 'challengeHistory',
        data() {
            return {
                theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
                info: []
            }
        },
        mounted() {
            document.documentElement.setAttribute("theme", this.theme)
            if (getQueryVariable("token")) {
                localStorage.setItem("token", getQueryVariable("token"));
            }
            this.getData();
        },
        methods: {
            back() {
                this.$router.back();
            },
            getData() {
                this.$api.sport.getChallengeList({
                    pageNum: 1,
                    pageSize: 300,
                    type: 1,
                }).then(res => {
                    this.info = res.info.items
                })
            },
            getDistanceDays(date1, date2) {
                return getDistanceDays(date1, date2)
            },
            formatSeconds(num) {
                return formatSeconds(num)
            },
            toDesc(item) {
                this.$router.push({
                    name: 'challengeDesc',
                    query: {
                        challengeId: item.challengeId,
                        userChallengeId: item.userChallengeId,
                        userId: this.userId,
                        lang: this.$i18n.locale,
                        theme: this.theme
                    }
                })
            },
            // 获取挑战赛名称
            getName(challenge) {
                if (challenge.attribute == 0) {
                    return this.$t('challengeType.attribute0.name')
                } else {
                    let monthNum = parseInt(challenge.name) - 1;
                    let monthDesc = this.$t('monthArr['+monthNum+']');
                    let name;
                    if (challenge.name.indexOf('骑行') != -1) {
                        name = this.$t('challengeType.attribute'+challenge.attribute+'骑行.name');
                    } else if (challenge.name.indexOf('跑步') != -1) {
                        name = this.$t('challengeType.attribute'+challenge.attribute+'跑步.name');
                    } else {
                        name = this.$t('challengeType.attribute'+challenge.attribute+'.name');
                    }
                    if (this.$i18n.locale === 'zh') {
                        return monthDesc+name;
                    } else {
                        return monthDesc+" "+name;
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .list {
        margin-top: 98px;
    }

    .c-box {
        width: 345px;
        height: 126px;
        background: var(--bg-color-2);
        border-radius: 13px 13px 13px 13px;
        margin: 10px auto 10px;
        position: relative;
    }

    .icon-box {
        width: 86px;
        height: 88px;
        background:  linear-gradient( 179deg, #E9FFF8 0%, #FFFFFF 100%);
        border-radius: 10px 10px 10px 10px;
        position: absolute;
        top: 21px;
        left: 16px;
    }

    .c-icon {
        height: 88px;
        float: right;
    }

    .c-title {
        font-size: 17px;
        color: var(--text-color-1);
        position: absolute;
        left: 115px;
        top: 21px;
    }

    .c-time {
        font-size: 12px;
        color: var(--text-color-3);
        position: absolute;
        left: 115px;
        top: 44px;
    }

    .time-icon {
        width: 16px;
        position: absolute;
        left: 115px;
        top: 66px;
    }

    .c-countdown {
        font-size: 15px;
        color: var(--text-color-1);
        position: absolute;
        left: 137px;
        top: 67px;
        line-height: 15px;
    }

    .c-light {
        color: var(--chart-color-1);
    }

    .rank-icon {
        width: 16px;
        position: absolute;
        left: 115px;
        top: 92px;
    }

    .c-rank {
        font-size: 15px;
        color: var(--text-color-2);
        position: absolute;
        left: 137px;
        top: 94px;
        line-height: 15px;
    }

    .info-icon {
        width: 16px;
        position: absolute;
        left: 115px;
        top: 66px;
    }

    .c-info {
        font-size: 15px;
        color: var(--text-color-2);
        position: absolute;
        left: 137px;
        top: 68px;
        line-height: 15px;
    }

    .join-icon {
        width: 38px;
        position: absolute;
        left: 277px;
        top: 72px;
    }
</style>



// WEBPACK FOOTER //
// src/views/sport/02challengeHistory.vue